import { useState } from 'react';
import { Box, Integration, IntegrationsBox, IntegrationsList, Wrapper } from '../style';

import SharepointLogo from '../../../assets/icons/sharepoint.svg?react';
import DropboxLogo from '../../../assets/icons/dropbox.svg?react';
import GDriveLogo from '../../../assets/icons/gdrive.svg?react';

import CloudUpload from '../../../components/CloudUpload';
import UploadFile from '../../../components/UploadFile';
import Modal from '../../../components/Modal';
import sidebarStore from '../../../store/sidebar';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

const Reportings = () => {
  const navigate = useNavigate();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const toggle = () => setIsOpenModal(prev => !prev);

  const onSelectIntegration = integration => {
    navigate(`${integration}/files`);
  };

  const handleSelectSharepoint = () => {
    onSelectIntegration('sharepoint');
  };

  const handleSelectDropbox = () => {
    onSelectIntegration('dropbox');
  };

  const handleSelectGDrive = () => {
    onSelectIntegration('gdrive');
  };

  return (
    <Wrapper>
      <Box>
        <h1>Upload file from Cloud storage</h1>
        <p>Upload file from Cloud storage</p>

        <div className="uploads">
          <div className="item">
            <UploadFile />
          </div>
          <div className="item" onClick={toggle}>
            <CloudUpload />
          </div>
        </div>
      </Box>

      <Modal
        open={isOpenModal}
        title="Choose cloud storage"
        toggle={toggle}
        isOpenSidebar={sidebarStore.isOpen}
      >
        <IntegrationsBox>
          <IntegrationsList>
            <Integration onClick={handleSelectSharepoint}>
              <SharepointLogo />
              <span></span> <p>Sharepoint</p>
            </Integration>
            <Integration onClick={handleSelectDropbox}>
              <DropboxLogo />
              <span></span> <p>Dropbox</p>
            </Integration>
            <Integration onClick={handleSelectGDrive}>
              <GDriveLogo />
              <span></span> <p>Google Drive</p>
            </Integration>
          </IntegrationsList>
        </IntegrationsBox>
      </Modal>
    </Wrapper>
  );
};

export default observer(Reportings);
